<template>
        <md-datepicker 
            id="datepicker-field"
            v-model="date"
            :md-disabled-dates="disabledDates"
            class="m-0 pt-0"
            md-immediately>
                <img 
                    :src="ICON_DATE"
                    alt="">
        </md-datepicker>
</template>

<script>
    import { ICON_DATE } from "../constants";

    export default {
        name: 'DatePicker',
        props: ['value'],
        data: function () {
            return {
                ICON_DATE,
                date: undefined,
            }
        },
        watch: {
            'date': 'onChange'
        },
        mounted: function () {
            this.date = this.value
        },
        methods: {
            disabledDates(data){
                return data<new Date();
            },
            onChange: function () {
                this.$emit('change', this.date)
            }
        }
    }
</script>
